import LazyLoad from 'vanilla-lazyload';

const lazyLoadInstance = new LazyLoad({
  // https://github.com/verlok/lazyload#-api
  elements_selector: '[data-directive-lazy-image]',
  class_loaded: '_loaded',
  class_loading: '_loading',
  class_error: '_loading-error',
});

export default {
  bind(el) {
   lazyLoadInstance.update([el]);
  },

  unbind() {},
};
